module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/property-c5c5999c07c54e7066218e9258db4fcf.svg";